import Vue from 'vue';
import Vuex from 'vuex';
import { rest } from "@/utilities/rest.js";

Vue.use(Vuex);

export default new Vuex.Store({

	modules: {
	},

	state: {

		user: null,
		admin: false,
		classes: [],
		allClasses: [],
		myClasses: [],
		passes: [],
		studios: [],
		allStudios: [],
		locations: [],
		classesConfig: {},
		reserveConfig: {},
		dialogWidth: "50%",

		joinSuccessTemplate: null

	},

	getters: {

		user: state => {
			return state.user;
		},

		admin: state => {
			return state.admin;
		},

		classes: state => {
			return state.classes;
		},

		allClasses: state => {
			return state.allClasses;
		},

		myClasses: state => {
			return state.myClasses;
		},

		passes: state => {
			return state.passes;
		},

		studios: state => {
			return state.studios;
		},

		allStudios: state => {
			return state.allStudios;
		},
		
		locations: state => {
			return state.locations;
		},

		modalWidth: state => {
			return state.dialogWidth;
		},

		classesConfig: state => {
			return state.classesConfig;
		},

		reserveConfig: state => {
			return state.reserveConfig;
		}

	},

	mutations: {
		setUser(state, payload) {
			state.user = payload;
		},
		
		setClasses(state, payload) {
			state.classes = payload;
		},

		setAllClasses(state, payload) {
			state.allClasses = payload;
		},

		setMyClasses(state, payload) {
			state.myClasses = payload;
		},

		setPasses(state, payload) {
			state.passes = payload;
		},
		
		setData(state, payload) {
			const config = JSON.parse(payload.config);
			console.log(config);
			state.admin = payload.admin;
			state.locations = config.shared.locations;
			state.reserveConfig = config.reserve;
			state.classes = payload.classes;
			state.user = payload.user;
			state.passes = payload.passes;
			state.studios = payload.studios;
			state.allStudios = payload.allStudios;
			state.joinSuccessTemplate = payload.joinSuccessTemplate;

		},

		setDialogWidth(state, payload) {
			state.dialogWidth = payload;
		}
	},

	actions: {
		getData: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Reserve/", "GetData", "json")
					.done(function (response) {
						context.commit("setData", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		getClasses: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Reserve/", "GetClasses", "json", { studioId: payload })
					.done(function (response) {
						context.commit("setClasses", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		getMyClasses: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Reserve/", "GetMyClasses", "json", {})
					.done(function (response) {
						context.commit("setMyClasses", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		getAllClasses: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Reserve/", "GetAllClasses", "json", { studioId: payload })
					.done(function (response) {
						context.commit("setAllClasses", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		getPasses: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Reserve/", "GetPasses", "json", { studioId: payload })
					.done(function (response) {
						context.commit("setPasses", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		
		
		reserve: (context, payload) => {
			return new Promise((resolve, reject) => {
				
				rest.post("Reserve/", "Reserve", "json", JSON.stringify(payload))
					.done(function (response) {
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		remove: (context, payload) => {
			return new Promise((resolve, reject) => {

				rest.post("Reserve/", "Remove", "json", JSON.stringify({ weid: payload }))
					.done(function (response) {
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		}


	}
})
